module.exports = __webpack_public_path__ + "img/info-img.49c53ec2.png";